import { Component, Input, OnInit, Output, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from '../../services';
import { Message, SignalRService } from '../../services/signalr.service';
import { AppStateHolder } from '../../shared';
import { Router } from '@angular/router';
import { apps, guid } from '../../constants';
import { DrawerModule } from 'primeng/drawer';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DrawerModule, TranslateModule]
})
export class SupportComponent implements OnInit {
  private _appService = inject(AppService);
  private _signalRService = inject(SignalRService);
  appStateHolder = inject(AppStateHolder);
  private _router = inject(Router);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }


  @Input() visible: boolean = false;
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  /** Mobile: drawer dal basso (bottom sheet); desktop: laterale destro. */
  get drawerPosition(): 'right' | 'bottom' {
    return window.innerWidth <= 640 ? 'bottom' : 'right';
  }

  ngOnInit(): void {
  }

  downloadLivelet() {
    const url = 'http://liveadmin.livecare.net/liveletexecustom/0K814OJ5854XRSRY';
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  closeSidebar() {
    this.close.emit(true);
  }

  /**
   * For specific request get request type and navigate to dialog
   * @param type
   */
  createRequest(type: string) {
    const url = this.appStateHolder.getAppUrl(apps.dialog);
    this.appStateHolder.setAppNavbarClass(apps.dialog);
    let id;
    switch (type) {
      case 'assistence':
        id = '6DF53635-3D05-4E81-B75A-E96CEEE6BD32';
        break;

      case 'feedback':
        id = '52CD3344-1696-4928-A088-8E86BBE33FB4';
        break;

      case 'technical':
        id = '03A66FBB-3A87-4EDC-BD68-487D49ED206F';
        break;

      default:
        break;
    }

    const urlParameter = `/support/create?requestTypeId=${id}&dataOwnerId=${guid.empty}`;
    const link = ['app', `${url}/createmodel/${encodeURIComponent(urlParameter)}`];
    this._router.navigate(link);
    this.closeSidebar();
  }
}
